import { render, staticRenderFns } from "./stu-volunteer-appoint.vue?vue&type=template&id=1f2b27c2&scoped=true"
import script from "./stu-volunteer-appoint.vue?vue&type=script&lang=js"
export * from "./stu-volunteer-appoint.vue?vue&type=script&lang=js"
import style0 from "./stu-volunteer-appoint.vue?vue&type=style&index=0&id=1f2b27c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b27c2",
  null
  
)

export default component.exports